<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">
        Associazione Profili
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Bottone di aggiunta -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="aggiungiAssociazione(item)"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary">mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Aggiungi</span>
      </v-tooltip>

      <!-- Bottone di salvataggio -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="salvaAssociazioni" small v-bind="attrs" v-on="on"
            ><v-icon color="success">mdi-floppy</v-icon></v-btn
          >
        </template>
        <span>Salva</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <!-- Bottone di chiusura -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="chiudiDialog" small v-bind="attrs" v-on="on"
            ><v-icon color="error">mdi-close</v-icon></v-btn
          >
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text class="mt-5" style="overflow-y: auto">
      <v-data-table
        :headers="headers_associazioni"
        :items="items_associazioni.filter((e) => e.validita == 1)"
      >
        <!-- Bottone di eliminazione -->
        <template v-slot:[`item.elimina`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="eliminaAssociazione(item)"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Elimina</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card-text>

    <v-dialog persistent v-model="dialog_aggiungi_profilo" width="500">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Aggiunta Profilo
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di chiusura del dialog di aggiunta profilo -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiDialogAggiungiProfilo"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Seleziona</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <!-- Tabella dei profili -->
          <v-data-table :headers="headers_profili" :items="items_profili">
            <!-- Bottone di selezione -->
            <template v-slot:[`item.seleziona`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="selezionaProfilo(item)"
                    v-bind="attrs"
                    v-on="on"
                    small
                  >
                    <v-icon color="success"> mdi-check </v-icon>
                  </v-btn>
                </template>
                <span>Seleziona</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Associazione {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "des_profilo_utente", default_val: "" },
      { nome: "id_layout", default_val: null },
      { nome: "id_layout_associazione", default_val: -1 },
      { nome: "id_profilo_utente", default_val: null },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}

export default {
  name: "AssociazioniLayout",
  components: { SnackbarQV },
  props: {
    id_layout_sel: {
      type: Number,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Variabili d'appoggio

      // Modal
      dialog_aggiungi_profilo: false,
      overlay: false,

      // Array
      headers_associazioni: [
        { text: "Profilo", value: "des_profilo_utente", sortable: false },
        { text: "Elimina", value: "elimina", sortable: false, width: "100px" },
      ],
      headers_profili: [
        {
          text: "Seleziona",
          value: "seleziona",
          sortable: false,
          width: "100px",
        },
        { text: "Profilo", value: "des_profilo_utente", sortable: false },
      ],
      items_associazioni: new Array(),
      items_profili: new Array(),
    };
  },
  computed: {},
  watch: {
    visible: {
      immediate: true,
      async handler() {
        if (this.visible === true) {
          /* Prendo la lista dei profili e la uso per cominciare
           * a generarmi delle strutture dai per le associazioni. */
          this.getProfili();

          /* Verifico se ci sono associazioni per quei profili
           * e completo la generazione delle strutture dati che
           * rappresentano le associazioni in FE. */
          this.getLayoutAssociazioni(this.id_layout_sel);
        }
      },
    },
  },
  methods: {
    aggiungiAssociazione() {
      this.dialog_aggiungi_profilo = true;
    },
    chiudiDialog() {
      this.$emit("click_chiudi");
    },
    chiudiDialogAggiungiProfilo() {
      this.dialog_aggiungi_profilo = false;
    },
    eliminaAssociazione(arg) {
      this.$set(arg, "validita", 0);
    },
    getLayout() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getlayout",
          token: localStorage.user_token,
          nome_modulo: "AVANZAMENTO",
          id_profilo: "",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          // Se la risposta è in 200...
          if (res.status === 200) {
            // Registro i layout disponibili.
            this.items_layout = res.data.result.layout;
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    getLayoutAssociazioni(arg) {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getlayoutassociazioni",
          token: localStorage.user_token,
          id_layout: arg,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_associazioni = res.data.result.associazioni;
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    getProfili() {
      var request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getprofili",
          token: localStorage.user_token,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_profili = new Array();

            res.data
              .filter((p) => p.validita == 1)
              .forEach((p) => {
                this.items_profili.push(new Associazione(p));
              });
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione con il server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione con il server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    salvaAssociazioni() {
      // Lascio da parte gli oggetti nuovi ma non validi.
      const arr_tmp = Array.from(
        this.items_associazioni.filter(
          (e) => e.id_layout_associazione > 0 || e.validita == 1
        )
      );

      // Faccio la chiamata al BE per salvare i dati,
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setlayoutassociazioni",
          token: localStorage.user_token,
          tabella: arr_tmp,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            /* Emetto un eventoper chiudere il dialog; il componente chiamante
             * gestendo l'evento stampa anche una snackbar di conferma. */
            this.$emit("salvate_associazioni");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile salvare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile salvare i dati."
          );
        });
    },
    async selezionaProfilo(arg) {
      /* Controllo se c'è già un'associazione
       * valida per questo profilo. */
      if (
        this.items_associazioni.filter(
          (e) => e.id_profilo_utente == arg.id_profilo_utente && e.validita == 1
        ).length > 0
      ) {
        this.$refs.SnackbarQV.print("orange", "Associazione già presente.");
        return;
      }

      // Aggiungo l'associazione alla lista.
      this.items_associazioni.push({
        id_layout_associazione: -1,
        id_profilo_utente: arg.id_profilo_utente,
        id_layout: this.id_layout_sel,
        validita: 1,
        des_profilo_utente: arg.des_profilo_utente,
      });

      // Chiudo la finestra di dialogo.
      this.dialog_aggiungi_profilo = false;
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>